import { render, staticRenderFns } from "./sidebar-bill-to-pax.vue?vue&type=template&id=40dfb004&"
import script from "./sidebar-bill-to-pax.vue?vue&type=script&lang=js&"
export * from "./sidebar-bill-to-pax.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-bill-to-pax.vue?vue&type=style&index=0&id=40dfb004&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports